// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__24FHN","fileBtn":"File_fileBtn__1WvwV","closeBtn":"File_closeBtn__138kX","fileSelected":"File_fileSelected__1aa2v","disabled":"File_disabled__1LEbq"};